
import React, { useEffect, useRef } from 'react';
import { IconButton, MenuItem, Menu, Divider, Alert, Tooltip, Typography } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import Modeler from 'bpmn-js/lib/Modeler';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import 'bpmn-js/dist/assets/bpmn-js.css';
import diagramXML from '../../resources/newDiagram.bpmn';
import MenuIcon from '@mui/icons-material/Menu';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import "./BpmnPanel.css";
import BmpnForm from './BpmnForm';
import Service from '../../util/Service';
import NodeRoot from './nodes/NodeRoot';
// import { Inventory2 } from '@mui/icons-material';
import PacoteComp from '../common/PacoteComp';
import BpmnEditorDialog from './BpmnEditorDialog';
import BPMCRUDPageDialog from '../page/portal/comps/BPMCRUDPageDialog';

// var modeler = null;
// export default function BpmnEditorPanel(props) {

const BpmnEditorPanel = React.forwardRef((props, ref) => {

    const { rootProcesso, stylePacote, maximizeable } = props;
    const bpmnPanel = useRef(null);
    const modelerRef = useRef(null);

    const navigate = useNavigate();
    const params = useParams();
    // const [searchParams, setSearchParams] = useSearchParams();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [openForm, setOpenForm] = React.useState(false);
    const [openProp, setOpenProp] = React.useState(false);
    const [fullScreen, setFullScreen]= React.useState(false);
    const [processo, setProcesso] = React.useState();
    const [workItem, setWorkItem] = React.useState();
    const [mensagem, setMensagem] = React.useState(null);
    const [needToSave, setNeedToSave] = React.useState(false);
    const [openCrud, setOpenCrud] = React.useState(false);

    const [menu, setMenu] = React.useState();
    let elementId = null;

    React.useImperativeHandle(ref, () => ({
        childFunction: () => {
            
        },
        getProcesso:()=>{
            return processo;
        },
        salva: async ()=>{
            await salvarProcesso(processo);
        }
    }));

    useEffect(() => {
        // if (!modeler) 
        {
            modelerRef.current = new Modeler({
                container:  bpmnPanel.current,
                // moddleExtensions: {
                //     custom: customModdleExtension
                // }
            });
            modelerRef.current.on('import.done', handleImporDone);
            modelerRef.current.on('element.changed', nodeChange);

            if (!(params && params.id) && !rootProcesso) {
                callOnInit();
            }
        }
        if (params && params.id) {
            buscaProcesso(params.id);
        } else if (rootProcesso) {
            buscaProcesso(rootProcesso.id);
        }
        return () => {            
            if (modelerRef.current) {
                modelerRef.current.destroy();
                modelerRef.current = null;                
            }
          };
    }, []);
    React.useEffect(() =>{
        if( !openProp ){
            if (params && params.id) {
                buscaProcesso(params.id);
            } else if (rootProcesso) {
                buscaProcesso(rootProcesso.id);
            }
        }
    },[openProp]);

    React.useEffect(() => {
        if (mensagem) {
            setTimeout(() => {
                setMensagem(null);
            }, 5000);
        }
    }, [mensagem])
    useEffect(() => {
        if (processo && processo.rodando) {
            setMenu([
                { nome: 'Salvar', action: 'salvar' },
                { nome: 'Propriedade', action: 'prop' },
                { nome: 'Parar execução', action: 'stop' },
                { nome: '', action: '' },
                { nome: 'Voltar', action: 'home' },
                { nome: 'Download', action: 'download' },
                { nome: '', action: '' },
                { nome: 'Ver em execução 1', action: 'seeData' },
                { nome: 'Exemplo Operação CRUD', action: 'crudModel' },
                { nome: 'Exportar', action: 'export' }
            ])
        } else if (processo) {
            setMenu([
                { nome: 'Salvar', action: 'salvar' },
                { nome: 'Editar', action: 'editar' },
                { nome: 'Propriedade', action: 'prop' },
                { nome: 'Executar', action: 'exec' },
                { nome: '', action: '' },
                { nome: 'Voltar', action: 'home' },
                { nome: 'Download', action: 'download' },
                { nome: '', action: '' },
                { nome: 'Exportar', action: 'export' }
            ])
        } else {
            setMenu([
                { nome: 'Salvar', action: 'salvar' },
                { nome: '', action: '' },
                { nome: 'Voltar', action: 'home' },
                { nome: 'Download', action: 'download' },
                { nome: '', action: '' },
                { nome: 'Exportar', action: 'export' }
            ])
        }
    }, [processo]);

    function update(){
        buscaProcesso(rootProcesso.id);
    }
    function handleMenu(action) {
        setNeedToSave(false);
        if (action === 'salvar') handleSalvar();
        if (action === 'editar') handleEditar();
        if (action === 'exec') handleExecutar();
        if (action === 'home') handleHome();
        if (action === 'prop') handleShowProperties();
        if (action === 'stop') handlePararProcesso();
        if (action === 'download') handleClickDonwload();
        if (action === 'export') handleClickExport();
        if (action === 'seeData') handleSeeData();
        if (action === 'crudModel') handleCRUD();        
    }
    const handleCRUD=() =>{        
        if( processo && processo.lstTask && processo.lstTask.length > 0){
            let isOk = false;
            fora: for(const item of processo.lstTask){
                if( item.categorias){
                    for(const cat of item.categorias){
                        if( cat === 'online'){
                            isOk = true;
                            break fora;
                        }
                    }
                }
            }
            if( !isOk){
                alert('Processo precisa ser da catetoria ON-LINE para poder fazer opeções CRUD.');
                return;    
            }
        }else{
            alert('Não é um processo correto para execução de CRUD!');
            return;
        }
        setOpenCrud(true);
    }
    const handleSeeData= async()=>{
        const task = processo.lstTask.find(t => t.idTask === 'newProcessID');
        if( task ){
            const online = task.categorias.find( c => c === 'online');
            if( online){
                // window.open('/api/bpmn/onLine/'+processo.nome)     
                window.open('/gerenciar/flowProcess/'+rootProcesso.id)
                // window.open('/gerenciar/bpm/see/'+rootProcesso.id) 
            }else{
                window.open('/gerenciar/flowProcess/'+(rootProcesso ? rootProcesso.id: processo.id) );
            }
        }else{
            // window.open('/gerenciar/bpm/see/'+rootProcesso.id) ;
            window.open('/gerenciar/flowProcess/'+(rootProcesso ? rootProcesso.id: processo.id) );
        }
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClickDonwload = async () => {
        try {
            const { xml } = await modelerRef.current.saveXML({ format: true });
            var filename = "diagram.bpmn";
            var pom = document.createElement('a');
            var bb = new Blob([xml], { type: 'text/plain' });
            pom.setAttribute('href', window.URL.createObjectURL(bb));
            pom.setAttribute('download', filename);
            pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
            pom.draggable = true;
            pom.classList.add('dragout');
            pom.click();
        } catch (err) {
            console.error('Error happened saving XML: ', err);
        }
    }
    function buscaProcesso(id) {
        if (!id) {
            setProcesso(rootProcesso);
            callOnInit();
            return;
        }
        Service.GET("/api/bpmn/buscaProcessoPorId/" + id).then(ret => {
            setProcesso(ret);
            buscaGridFSFileById(ret.idBpmn)
        });
    }
    function buscaGridFSFileById(id) {
        const url = "/api/bpmn/GridFSFileById/" + id;
        fetch(url, { headers: { Authorization: `Bearer ${localStorage.accessToken}` } })
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                try {
                    modelerRef.current.importXML(text);
                } catch (err) {
                    console.error(err)
                }
            })["catch"](function (err) {
                console.error(">>>erro: ", err)
            });
    }
    function handleHome() {
        navigate("/");
        // navigate(0);
        handleClose();
    }
    function handleClickExport() {
        let id = params.id;
        if( !id) id = processo.id;
        
        Service.DOWNLOAD("/api/bpmn/export/" + id, processo.nome + ".zip").then(ret => {
            // setProcesso(ret);
            // navigate("/editBPM/"+params.id);
            // navigate(0);
        });
        handleClose();
    }
    function handleSalvar() {
        if( rootProcesso){
            salvarProcesso(processo);
        }else{
            if (params && params.id) {
                salvarProcesso(processo);
            } else {
                setOpenForm(true)
            }
        }
        handleClose();
    }
    function handleEditar() {
        setOpenForm(true)
        handleClose();
    }
    function handleExecutar() {
        Service.GET("/api/bpmn/executarProcesso/" + processo.id).then(ret => {
            if (params && params.id) {
                buscaProcesso(params.id);
            } else if (rootProcesso) {
                buscaProcesso(rootProcesso.id);
            }
        });
        handleClose();
    }
    function handlePararProcesso() {
        Service.GET("/api/bpmn/pararProcessoProcesso/" + processo.id).then(ret => {
            // navigate("/editBPM/" + processo.id);
            // navigate(0);
        });
        handleClose();
    }
    function handleShowProperties() {
        if (!workItem) {
            setMensagem('Nenhum nó selecionado');
            handleClose();
            return;
        }
        setOpenProp(true);
        handleClose();
    }
    const salvarProcesso = async (pro) => {
        if( !pro.id){
            alert('É necessario salvar os dados do processo antes de salvar o modelo.');
            handleEditar();
            return;
        }
        setProcesso(pro);
        const url = '/api/bpmn/salvarBpmn?id=' + pro.id;
        const { xml } = await modelerRef.current.saveXML(); //await modeler.saveXML({ format: true });
        Service.UPLOAD(url, xml).then(resp => {
            if(rootProcesso){
                navigate("/recursos/"+ pro.id, { replace: true } );
                 return;         
            }
            if (!params || !params.id) {
                navigate("/editBPM/" + pro.id, { replace: true })
            }
        }).catch(error => {
            console.error(error);
        })
    }

    const handleImporDone = (event) => {
        var error = event.error,
            warnings = event.warnings;
        if (error) {
            alert('Falha, modelo corrompido!');
            navigate(0);
            return;
        }
        var eventBus = modelerRef.current.get('eventBus');
        var events = ['element.mouseup'];
        events.forEach(function (event) {
            eventBus.off(event);
            eventBus.on(event, handleEvenBusEvent);
        });
        modelerRef.current.get('canvas').zoom('fit-viewport', 'auto');
    }
    const nodeChange = (event) => {
        setNeedToSave(true);
        const element = event.element;        
        if( element.type === "bpmn:ExclusiveGateway" || element.type === "bpmn:ParallelGateway"){
            let proc;
            if( !processo){
                proc = {...rootProcesso};
            }else{
                proc = {...processo};
            }
            if( !proc || !proc.lstTask) return;            
            const task = proc.lstTask.find( t => t.idTask === element.id);
            task.taskType = element.type;
            handleUpdateProcesso(proc);
        }
    }
    const handleEvenBusEvent = (e) => {
        if (elementId === e.element.id) {
            setWorkItem();
            elementId = null;
        } else {
            elementId = e.element.id;
            setWorkItem(e.element);
        }
    }
    function callOnInit(nameParameter) {
        fetch(diagramXML).then(function (response) {
            return response.text();
        }).then(function (text) {
            try {
                modelerRef.current.importXML(text);
                modelerRef.current.get('canvas').zoom('fit-viewport');

            } catch (err) {
                console.error(err)
            }
        })["catch"](function (err) {
            console.error(">>>erro: ", err)
        });
    }

    function upload(e) {
        // let file = document.getElementById("file");
        var file = e.target.files[0];
        if (!file) {
            return;
        }
        if (file.name.toLowerCase().indexOf(".xml") < 0 && file.name.toLowerCase().indexOf(".bpmn") < 0) {
            alert('Tipo de arquivo não esperado')
            return;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
            var contents = e.target.result;
            try {
                
                modelerRef.current.importXML(contents);
            } catch (err) {
                console.err(err)
            }
        };
        reader.readAsText(file);
    }
    function handleUpdateProcesso(proc){
        Service.POST("/api/bpmn/salvarProcesso", proc).then(ret => {            
            setProcesso(ret);
        });
    }
    function handleUpdatePacote(pk) {
        const dado = {
            idProcesso: processo.id,
            pacote: pk
        }
        Service.POST("/api/bpmn/salvaPacoteProcesso", dado).then(ret => {
            var p = { ...processo };
            p.pacote = pk
            setProcesso(p);

        });
        handleClose();
    }
    function nomeClasse(txt){
        if( txt){
            return txt.replaceAll(" ", "_");
        }
        return '';
    }
    async function handleAbrirPaginaCheia(){
        navigate("/editBPM/"+processo.id);

    }
    return (
        <div>
            {maximizeable === true && <div className="posiciona"
                style={{                    
                    right: 45
                }}
            >
            <Tooltip title="Abrir pagina cheia">
                <IconButton
                    size="small"
                    color="inherit"
                    
                    onClick={handleAbrirPaginaCheia}
                >
                    <OpenInFullIcon />
                </IconButton>
            </Tooltip>
            </div>}
            <div className="posiciona"
                
            >
                <IconButton size="small"
                    color="inherit" onClick={handleClick}
                >
                    <MenuIcon />
                </IconButton>
            </div>
            <PacoteComp
                classeName={processo && processo.nome} pack={processo && processo.pacote}
                action={handleUpdatePacote}
                style={stylePacote}
            >
                {workItem && <ul className="minimalita">
                    <li className='minimalita'>
                        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                            Processo:{processo.nome}
                        </Typography>
                    </li>
                    <li className='minimalita'>
                        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                            Tipo:{workItem.type}
                        </Typography>
                    </li>
                    {/* <li className='minimalita'>
                        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                            Nome:{workItem.di.bpmnElement.name?workItem.di.bpmnElement.name:'Sem nome'}
                        </Typography>
                    </li> */}
                    <li className='minimalita'>
                        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                            Classe:{nomeClasse(workItem.di.bpmnElement.name?workItem.di.bpmnElement.name:'Sem nome')}
                        </Typography>
                    </li>
                    <li className='minimalita'>
                        <Typography variant="caption" gutterBottom sx={{ display: 'block' }}>
                            ID:{workItem.di.bpmnElement.id}
                        </Typography>
                    </li>
                    </ul>
                }
                </PacoteComp>

            <div ref={bpmnPanel}
                style={{
                    height: '90vh',
                    width: '90%'
                }}
            />

            <input type="file" id="file" style={{ display: 'none' }} onChange={upload} />


            <Menu
                id="b'asic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                // MenuListProps={{
                //     'aria-labelledby': 'basic-button',
                // }}
            >
                {menu && menu.map((m, i) => {
                    if (m.nome === '') return (<Divider key={i} variant="middle" component="li" />);
                    else {
                        if( needToSave ){
                            if( m.nome ==="Salvar") return <MenuItem key={i} onClick={() => handleMenu(m.action)}>{m.nome}</MenuItem>;
                            else return <MenuItem key={i} disabled={true} >{m.nome}</MenuItem>;
                        }else return <MenuItem key={i} onClick={() => handleMenu(m.action)}>{m.nome}</MenuItem>;
                    }
                }
                )}
            </Menu>
            {mensagem && <div className='float-botton'
                open={mensagem != null}
            >
                <Alert variant="outlined" severity="warning">
                    {mensagem}
                </Alert>
            </div>}

            <BmpnForm open={openForm} setOpen={setOpenForm} onSubmit={salvarProcesso} processo={processo} />
            <NodeRoot open={openProp} setOpen={setOpenProp} item={workItem} processo={processo} />
            <BpmnEditorDialog 
                open={fullScreen} 
                setOpen={setFullScreen} 
                rootProcesso={processo} 
                stylePacote={stylePacote}
                action={update}
            />
            <BPMCRUDPageDialog open={openCrud} setOpen={setOpenCrud} processo={processo}/>
        </div>
    );
});

export default BpmnEditorPanel;